const display = {
    name: "display",
    path: "/display",
    title: "display",
    description: "Utilities for controlling the display box type of an element.",
    value: {
        "display": {
            'block': "block",
        'hidden': "none",
        "inline-block": "inline-block",
        'inline': "inline",
        'flex': "flex",
        "inline-flex": "inline-flex",
        'grid': "grid",
        "inline-grid": "inline-grid",
        'table': "table",
        'contents': "contents",
        'list-item': "list-item",
        'flow-root': "flow-root",
        "inline-table": "inline-table",
        "table-caption": "table-caption",
        "table-cell": "table-cell",
        "table-column": "table-column",
        "table-column-group": "table-column-group",
        "table-footer-group": "table-footer-group",
        "table-header-group": "table-header-group",
        "table-row-group": "table-row-group",
        "table-row": "table-row",
        }
    },
    exampleData: [
        {
            "title": "",
            "description": "",
            "example": {
                "element": "",
                "src": "",
                "className": "",
                "code": `<p>
  When controlling the flow of text, using the CSS property <span class="inline">display: inline</span> will cause the
  text inside the element to wrap normally.
</p>
<p>
  While using the property <span class="inline-block">display: inline-block</span> will wrap the element to prevent the
  text inside from extending beyond its parent.
</p>
<p>
  Lastly, using the property <span class="block">display: block</span> will put the element on its own line and fill its
  parent.
</p>`
            }
        },
        {
            "title": "",
            "description": "",
            "example": {
                "element": "",
                "src": "",
                "className": "",
                "code": `<div class="p-4">
  <div class="flow-root ...">
    <div class="my-4 ...">Well, let me tell you something, ...</div>
  </div>
  <div class="flow-root ...">
    <div class="my-4 ...">Sure, go ahead, laugh if you want...</div>
  </div>
</div>`
            }
        },
        {
            "title": "",
            "description": "",
            "example": {
                "element": "",
                "src": "",
                "className": "",
                "code": `<div class="flex items-center">
  <img src="path/to/image.jpg" />
  <div>
    <strong>Andrew Alfred</strong>
    <span>Technical advisor</span>
  </div>
</div>`
            }
        },
        {
            "title": "",
            "description": "",
            "example": {
                "element": "",
                "src": "",
                "className": "",
                "code": `<p>
  Today I spent most of the day researching ways to ...
  <span class="inline-flex items-baseline">
    <img src="/img/kramer.jpg" class="mx-1 size-5 self-center rounded-full" />
    <span>Kramer</span>
  </span>
  keeps telling me there is no way to make it work, that ...
</p>`
            }
        },
        {
            "title": "",
            "description": "",
            "example": {
                "element": "",
                "src": "",
                "className": "",
                "code": `<div class="grid grid-columns-3 grid-rows-3 gap-4">
  <!-- ... -->
</div>`
            }
        },
        {
            "title": "",
            "description": "",
            "example": {
                "element": "",
                "src": "",
                "className": "",
                "code": `<span class="inline-grid grid-cols-3 gap-4">
  <span>01</span>
  <span>02</span>
  <span>03</span>
  <span>04</span>
  <span>05</span>
  <span>06</span>
</span>
<span class="inline-grid grid-cols-3 gap-4">
  <span>01</span>
  <span>02</span>
  <span>03</span>
  <span>04</span>
  <span>05</span>
  <span>06</span>
</span>`
            }
        },

        {
            "title": "",
            "description": "",
            "example": {
                "element": "",
                "src": "",
                "className": "",
                "code": `<div class="flex ...">
  <div class="flex-1 ...">01</div>
  <div class="contents">
    <div class="flex-1 ...">02</div>
    <div class="flex-1 ...">03</div>
  </div>
  <div class="flex-1 ...">04</div>
</div>`
            }

        },
        {
            "title": "",
            "description": "",
            "example": {
                "element": "",
                "src": "",
                "className": "",
                "code": `<div class="table w-full ...">
  <div class="table-header-group ...">
    <div class="table-row">
      <div class="table-cell text-left ...">Song</div>
      <div class="table-cell text-left ...">Artist</div>
      <div class="table-cell text-left ...">Year</div>
    </div>
  </div>
  <div class="table-row-group">
    <div class="table-row">
      <div class="table-cell ...">The Sliding Mr. Bones (Next Stop, Pottersville)</div>
      <div class="table-cell ...">Malcolm Lockyer</div>
      <div class="table-cell ...">1961</div>
    </div>
    <div class="table-row">
      <div class="table-cell ...">Witchy Woman</div>
      <div class="table-cell ...">The Eagles</div>
      <div class="table-cell ...">1972</div>
    </div>
    <div class="table-row">
      <div class="table-cell ...">Shining Star</div>
      <div class="table-cell ...">Earth, Wind, and Fire</div>
      <div class="table-cell ...">1975</div>
    </div>
  </div>
</div>`
            }

        },
        {
            "title": "",
            "description": "",
            "example": {
                "element": "",
                "src": "",
                "className": "",
                "code": `<div class="flex ...">
  <div class="hidden ...">01</div>
  <div>02</div>
  <div>03</div>
</div>`
            }

        },
        {
            "title": "",
            "description": "",
            "example": {
                "element": "",
                "src": "",
                "className": "",
                "code": `<a href="#">
  <svg><!-- ... --></svg>
  <span class="sr-only">Settings</span>
</a>`
            }

        },
        {
            "title": "",
            "description": "",
            "example": {
                "element": "",
                "src": "",
                "className": "",
                "code": `<a href="#">
  <svg><!-- ... --></svg>
  <span class="sr-only sm:not-sr-only">Settings</span>
</a>`
            }

        },
    ],
    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">inline, inline-block</code> and
                <code class="text-color-gray-800 dark:text-color-white font-semibold">block </code>
                utilities to control the flow of text and elements:
            </p>
            <div class="leading-6 sm:leading-7 mx-auto max-w-xs px-4 text-sm  text-color-gray-500 sm:text-base dark:text-color-gray-300">When controlling the flow of text, using the CSS property <span class="inline rounded bg-color-sky-100 font-mono text-sm font-bold text-color-gray-900 dark:bg-color-white/15 dark:text-color-gray-200">display: inline</span> will cause the text inside the element to wrap normally.
            <br>
            <br>While using the property <span class="inline-block rounded bg-color-sky-100 font-mono text-sm font-bold text-color-gray-900 dark:bg-color-white/15 dark:text-color-gray-200">display: inline-block</span> will wrap the element to prevent the text inside from extending beyond
            its parent.
            <br>
            <br>Lastly, using the property <span class="block rounded bg-color-sky-100 font-mono text-sm font-bold text-color-gray-900 dark:bg-color-white/15 dark:text-color-gray-200">display: block</span> will put the element on its own line and fill its parent.</div>
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">flow-root</code>
                 utility to create a block-level element with its own block formatting context:
            </p>
<div class="mx-auto mb-10 max-w-xs p-4 text-sm leading-6 text-color-gray-500 sm:text-base sm:leading-7 dark:text-color-gray-300">
                <div class="relative mb-0.5 flow-root">
                    <div class="absolute inset-x-0">
                        <div class="h-4 w-full border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)]"></div>
                    </div>
                    <div class="absolute inset-x-0 bottom-0">
                        <div class="h-4 border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)]"></div>
                    </div>
                    <div class="my-4">Well, let me tell you something, funny boy. Y'know that little stamp, the one that says "New York Public Library"? Well that may not mean anything to you, but that means a lot to me. One whole hell of a lot.</div>
                </div>
                <div class="relative mt-0.5 flow-root">
                    <div class="absolute inset-x-0">
                        <div class="h-4 w-full border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)]"></div>
                    </div>
                    <div class="absolute inset-x-0 bottom-0">
                        <div class="h-4 border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)]"></div>
                    </div>
                    <div class="my-4">Sure, go ahead, laugh if you want to. I've seen your type before: Flashy, making the scene, flaunting convention. Yeah, I know what you're thinking. What's this guy making such a big stink about old library books? Well, let me give you a hint,
                        junior.</div>
                </div>
            </div>
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">flex</code>
                  utility to create a block-level flex container:
            </p>
            <div class="mx-auto flex max-w-xs justify-center p-4 leading-6 text-color-gray-500 dark:text-color-gray-400">
    <div class="flex items-center gap-4 p-4"><img class="h-12 w-12 rounded-full" src="https://images.unsplash.com/photo-1501196354995-cbb51c65aaea?ixlib=rb-1.2.1&amp;ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&amp;auto=format&amp;fit=facearea&amp;facepad=4&amp;w=256&amp;h=256&amp;q=80"/>
        <div
        class="flex flex-col"><strong class="font-medium text-color-gray-900 dark:text-color-gray-200">Andrew Alfred</strong><span class="font-medium text-color-gray-500 dark:text-color-gray-400 text-sm">Technical advisor</span></div>
</div>
</div>
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">inline-flex</code>
                  utility to create an inline flex container that flows with text:
            </p>
            <p class="mx-auto max-w-lg p-4 text-sm leading-6 text-color-gray-500 sm:text-sm dark:text-color-gray-300">Today I spent most of the day researching ways to take advantage of the fact that bottles can be returned for 10 cents in Michigan, but only 5 cents here. <span class="ml-1 inline-flex items-baseline"><img alt="" class="mr-1 size-5 self-center rounded-full" src="https://images.unsplash.com/photo-1501196354995-cbb51c65aaea?ixlib=rb-1.2.1&amp;ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&amp;auto=format&amp;fit=facearea&amp;facepad=4&amp;w=256&amp;h=256&amp;q=80"/><span class="font-medium text-color-gray-900 dark:text-color-gray-100">Kramer</span></span>
    keeps telling me there is no way to make it work, that he has run the numbers on every possible approach, but I just have to believe there's a way to make it work, there's simply too much opportunity here.</p>
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">grid </code>
                  utility to create a grid container:
            </p>
            
            <div class="p-4 relative rounded-lg text-center font-mono text-sm leading-6 font-bold text-color-white">
                <div class="absolute inset-0">
                    <div class="h-full rounded-lg border text-color-black/10 dark:text-color-white/12.5 bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)]"></div>
                </div>
                <div class="*:relative *:rounded-lg *:bg-color-purple-500 *:p-4  grid grid-columns-3 grid-rows-3 gap-4">
                    <div>01</div>
                    <div>02</div>
                    <div>03</div>
                    <div>04</div>
                    <div>05</div>
                    <div>06</div>
                    <div>07</div>
                    <div>08</div>
                    <div>09</div>
                </div>
            </div>
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">inline-grid </code>
                  utility to create an inline grid container:
            </p>
            
            <div class="w-full space-x-3 overflow-x-auto p-8 whitespace-nowrap">
                <div class="inline-grid  grid-columns-3 grid-rows-3 gap-4 relative rounded-lg text-center font-mono text-sm leading-6 font-bold text-color-white">
                <div class="absolute inset-0">
                    <div class="h-full rounded-lg border text-color-black/10 dark:text-color-white/12.5 bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)]"></div>
                </div>
                    <div class="relative rounded-lg bg-color-purple-500 p-4">01</div>
                    <div class="relative rounded-lg bg-color-purple-500 p-4">02</div>
                    <div class="relative rounded-lg bg-color-purple-500 p-4">03</div>
                    <div class="relative rounded-lg bg-color-purple-500 p-4">04</div>
                    <div class="relative rounded-lg bg-color-purple-500 p-4">05</div>
                    <div class="relative rounded-lg bg-color-purple-500 p-4">06</div>
                    <div class="relative rounded-lg bg-color-purple-500 p-4">07</div>
                    <div class="relative rounded-lg bg-color-purple-500 p-4">08</div>
                    <div class="relative rounded-lg bg-color-purple-500 p-4">09</div>
            </div>
            <div class="inline-grid  grid-columns-3 grid-rows-3 gap-4 relative rounded-lg text-center font-mono text-sm leading-6 font-bold text-color-white">
                <div class="absolute inset-0">
                    <div class="h-full rounded-lg border text-color-black/10 dark:text-color-white/12.5 bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)]"></div>
                </div>
                    <div class="relative rounded-lg bg-color-purple-500 p-4">01</div>
                    <div class="relative rounded-lg bg-color-purple-500 p-4">02</div>
                    <div class="relative rounded-lg bg-color-purple-500 p-4">03</div>
                    <div class="relative rounded-lg bg-color-purple-500 p-4">04</div>
                    <div class="relative rounded-lg bg-color-purple-500 p-4">05</div>
                    <div class="relative rounded-lg bg-color-purple-500 p-4">06</div>
                    <div class="relative rounded-lg bg-color-purple-500 p-4">07</div>
                    <div class="relative rounded-lg bg-color-purple-500 p-4">08</div>
                    <div class="relative rounded-lg bg-color-purple-500 p-4">09</div>
            </div>
            </div>
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">contents</code>
                  utility to create a "phantom" container whose children act like direct children of the parent:
            </p>
            <div class="relative flex gap-4 rounded-lg text-center font-mono text-sm leading-6 font-bold text-color-white">
                <div class="absolute inset-0">
                    <div class="h-full rounded-lg border text-color-black/10 dark:text-color-white/12.5 bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)]"></div>
                </div>
                <div class="relative flex-1 rounded-lg bg-color-purple-500 p-4">01</div>
                <div class="relative contents">
                    <div class="relative flex-1 rounded-lg bg-color-purple-500 p-4">02</div>
                    <div class="relative flex-1 rounded-lg bg-color-purple-500 p-4">03</div>
                </div>
                <div class="relative flex-1 rounded-lg bg-color-purple-500 p-4">04</div>
            </div>
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">table, table-row, table-cell, table-caption, table-column, table-column-group, table-header-group, table-row-group and table-footer-group</code>
                  utilities to create elements that behave like their respective table elements:
            </p>
            <div class="mt-8 overflow-hidden">
                <div class="table w-full table-auto border-collapse text-sm">
                    <div class="table-header-group">
                        <div class="table-row">
                            <div class="table-cell border-b border-color-gray-200 p-4 pt-0 pb-3 pl-8 text-left font-medium text-color-gray-400 dark:border-color-white/20 dark:text-color-white">Song</div>
                            <div class="table-cell border-b border-color-gray-200 p-4 pt-0 pb-3 text-left font-medium text-color-gray-400 dark:border-color-white/20 dark:text-color-white">Artist</div>
                            <div class="table-cell border-b border-color-gray-200 p-4 pt-0 pr-8 pb-3 text-left font-medium text-color-gray-400 dark:border-color-white/20 dark:text-color-white">Year</div>
                        </div>
                    </div>
                    <div class="table-row-group dark:bg-color-black/5">
                        <div class="table-row">
                            <div class="table-cell border-b border-color-gray-100 p-4 pl-8 text-color-gray-500 dark:border-color-white/10 dark:text-color-gray-300">The Sliding Mr. Bones (Next Stop, Pottersville)</div>
                            <div class="table-cell border-b border-color-gray-100 p-4 text-color-gray-500 dark:border-color-white/10 dark:text-gray-color-300">Malcolm Lockyer</div>
                            <div class="table-cell border-b border-color-gray-100 p-4 pr-8 text-color-gray-500 dark:border-color-white/10 dark:text-color-gray-300">1961</div>
                        </div>
                        <div class="table-row">
                            <div class="table-cell border-b border-color-gray-100 p-4 pl-8 text-color-gray-500 dark:border-color-white/10 dark:text-color-gray-300">Witchy Woman</div>
                            <div class="table-cell border-b border-color-gray-100 p-4 text-color-gray-500 dark:border-color-white/10 dark:text-gray-color-300">The Eagles</div>
                            <div class="table-cell border-b border-color-gray-100 p-4 pr-8 text-color-gray-500 dark:border-color-white/10 dark:text-color-gray-300">1961</div>
                        </div>
                        <div class="table-row">
                            <div class="table-cell border-b border-color-gray-100 p-4 pl-8 text-color-gray-500 dark:border-color-white/10 dark:text-color-gray-300">Shining Star</div>
                            <div class="table-cell border-b border-color-gray-100 p-4 text-color-gray-500 dark:border-color-white/10 dark:text-gray-color-300">Earth, Wind, and Fire</div>
                            <div class="table-cell border-b border-color-gray-100 p-4 pr-8 text-color-gray-500 dark:border-color-white/10 dark:text-color-gray-300">1961</div>
                        </div>
                    </div>
                </div>
            </div>
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">hidden </code>
                  utility to remove an element from the document:
            </p>
            <div class="relative flex gap-4 rounded-lg text-center font-mono text-sm leading-6 font-bold text-color-white">
                <div class="absolute inset-0">
                    <div class="h-full rounded-lg border text-color-black/10 dark:text-color-white/12.5 bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)]"></div>
                </div>
                <div class="hidden h-14 w-14 rounded-lg bg-color-purple-500 p-4">01</div>
                <div class="relative h-14 w-14 rounded-lg bg-color-purple-500 p-4">02</div>
                <div class="relative h-14 w-14 rounded-lg bg-color-purple-500 p-4">03</div>
            </div>
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 ">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">sr-only</code>
                  to hide an element visually without hiding it from screen readers:
            </p>
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 ">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">not-sr-only</code>
                  making an element visible to sighted users as well as screen readers:
            </p>
            `
        }
    ]
};

export default display;

<div className="sr-only">
    <div class="mx-auto max-w-xs px-4 text-sm leading-6 text-color-gray-500 sm:text-base sm:leading-7 dark:text-color-gray-300">When controlling the flow of text, using the CSS property <span class="inline rounded bg-color-sky-100 font-mono text-sm font-bold text-color-gray-900 dark:bg-color-white/15 dark:text-color-gray-200">display: inline</span> will cause the text inside the element to wrap normally.
        <br />
        <br />While using the property <span class="inline-block rounded bg-color-sky-100 font-mono text-sm font-bold text-color-gray-900 dark:bg-color-white/15 dark:text-color-gray-200">display: inline-block</span> will wrap the element to prevent the text inside from extending beyond
        its parent.
        <br />
        <br />Lastly, using the property <span class="block rounded bg-color-sky-100 font-mono text-sm font-bold text-color-gray-900 dark:bg-color-white/15 dark:text-color-gray-200">display: block</span> will put the element on its own line and fill its parent.</div>


    <div class="mx-auto mb-10 max-w-xs p-4 text-sm leading-6 text-gray-500 sm:text-base sm:leading-7 dark:text-gray-300">
        <div class="relative mb-0.5 flow-root">
            <div class="absolute inset-x-0">
                <div class="h-4 w-full border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)]"></div>
            </div>
            <div class="absolute inset-x-0 bottom-0">
                <div class="h-4 border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)]"></div>
            </div>
            <div class="my-4">Well, let me tell you something, funny boy. Y'know that little stamp, the one that says "New York Public Library"? Well that may not mean anything to you, but that means a lot to me. One whole hell of a lot.</div>
        </div>
        <div class="relative mt-0.5 flow-root">
            <div class="absolute inset-x-0">
                <div class="h-4 w-full border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)]"></div>
            </div>
            <div class="absolute inset-x-0 bottom-0">
                <div class="h-4 border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)]"></div>
            </div>
            <div class="my-4">Sure, go ahead, laugh if you want to. I've seen your type before: Flashy, making the scene, flaunting convention. Yeah, I know what you're thinking. What's this guy making such a big stink about old library books? Well, let me give you a hint,
                junior.</div>
        </div>
    </div>

    <div class="mx-auto flex max-w-xs justify-center p-4 leading-6 text-color-gray-500 dark:text-color-gray-400">
        <div class="flex items-center gap-4 p-4"><img class="h-12 w-12 rounded-full" src="https://images.unsplash.com/photo-1501196354995-cbb51c65aaea?ixlib=rb-1.2.1&amp;ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&amp;auto=format&amp;fit=facearea&amp;facepad=4&amp;w=256&amp;h=256&amp;q=80" />
            <div
                class="flex flex-col"><strong class="font-medium text-color-gray-900 dark:text-color-gray-200">Andrew Alfred</strong><span class="font-medium text-color-gray-500 dark:text-color-gray-400">Technical advisor</span></div>
        </div>
    </div>
    <p class="mx-auto max-w-lg p-4 text-sm leading-6 text-color-gray-500 sm:text-sm dark:text-color-gray-300">Today I spent most of the day researching ways to take advantage of the fact that bottles can be returned for 10 cents in Michigan, but only 5 cents here. <span class="ml-1 inline-flex items-baseline"><img alt="" class="mr-1 size-5 self-center rounded-full" src="https://images.unsplash.com/photo-1501196354995-cbb51c65aaea?ixlib=rb-1.2.1&amp;ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&amp;auto=format&amp;fit=facearea&amp;facepad=4&amp;w=256&amp;h=256&amp;q=80" /><span class="font-medium text-color-gray-900 dark:text-color-gray-100">Kramer</span></span>
        keeps telling me there is no way to make it work, that he has run the numbers on every possible approach, but I just have to believe there's a way to make it work, there's simply too much opportunity here.</p>

    <div class=" p-4 relative rounded-lg text-center font-mono text-sm leading-6 font-bold text-color-white">
        <div class="absolute inset-0">
            <div class="h-full rounded-lg border text-color-black/10 dark:text-color-white/12.5 bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)]"></div>
        </div>
        <div class="*:relative *:rounded-lg *:bg-color-purple-500 *:p-4  grid grid-columns-3 grid-rows-3 gap-4">
            <div>01</div>
            <div>02</div>
            <div>03</div>
            <div>04</div>
            <div>05</div>
            <div>06</div>
            <div>07</div>
            <div>08</div>
            <div>09</div>
        </div>
    </div>

    <div class="w-full space-x-3 overflow-x-auto p-8 whitespace-nowrap">
        <div class="inline-grid  grid-columns-3 grid-rows-3 gap-4 relative rounded-lg text-center font-mono text-sm leading-6 font-bold text-color-white">
            <div class="absolute inset-0">
                <div class="h-full rounded-lg border text-color-black/10 dark:text-color-white/12.5 bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)]"></div>
            </div>
            <div>
                <div class="relative rounded-lg bg-color-purple-500 p-4">01</div>
                <div class="relative rounded-lg bg-color-purple-500 p-4">02</div>
                <div class="relative rounded-lg bg-color-purple-500 p-4">03</div>
                <div class="relative rounded-lg bg-color-purple-500 p-4">04</div>
                <div class="relative rounded-lg bg-color-purple-500 p-4">05</div>
                <div class="relative rounded-lg bg-color-purple-500 p-4">06</div>
                <div class="relative rounded-lg bg-color-purple-500 p-4">07</div>
                <div class="relative rounded-lg bg-color-purple-500 p-4">08</div>
                <div class="relative rounded-lg bg-color-purple-500 p-4">09</div>
            </div>
        </div>
        <div class="inline-grid  grid-columns-3 grid-rows-3 gap-4 relative rounded-lg text-center font-mono text-sm leading-6 font-bold text-color-white">
            <div class="absolute inset-0">
                <div class="h-full rounded-lg border text-color-black/10 dark:text-color-white/12.5 bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)]"></div>
            </div>
            <div>
                <div class="relative rounded-lg bg-color-purple-500 p-4">01</div>
                <div class="relative rounded-lg bg-color-purple-500 p-4">02</div>
                <div class="relative rounded-lg bg-color-purple-500 p-4">03</div>
                <div class="relative rounded-lg bg-color-purple-500 p-4">04</div>
                <div class="relative rounded-lg bg-color-purple-500 p-4">05</div>
                <div class="relative rounded-lg bg-color-purple-500 p-4">06</div>
                <div class="relative rounded-lg bg-color-purple-500 p-4">07</div>
                <div class="relative rounded-lg bg-color-purple-500 p-4">08</div>
                <div class="relative rounded-lg bg-color-purple-500 p-4">09</div>
            </div>
        </div>
    </div>

    <div class="relative flex gap-4 rounded-lg text-center font-mono text-sm leading-6 font-bold text-white">
        <div class="absolute inset-0">
            <div class="h-full rounded-lg border text-color-black/10 dark:text-color-white/12.5 bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)]"></div>
        </div>
        <div class="relative flex-1 rounded-lg bg-color-purple-500 p-4">01</div>
        <div class="relative contents">
            <div class="relative flex-1 rounded-lg bg-color-purple-500 p-4">02</div>
            <div class="relative flex-1 rounded-lg bg-color-purple-500 p-4">03</div>
        </div>
        <div class="relative flex-1 rounded-lg bg-color-purple-500 p-4">04</div>
    </div>
<div class="mt-8 overflow-hidden">
                <div class="table w-full table-auto border-collapse text-sm">
                    <div class="table-header-group">
                        <div class="table-row">
                            <div class="table-cell border-b border-color-gray-200 p-4 pt-0 pb-3 pl-8 text-left font-medium text-color-gray-400 dark:border-color-white/20 dark:text-color-white">Song</div>
                            <div class="table-cell border-b border-color-gray-200 p-4 pt-0 pb-3 text-left font-medium text-color-gray-400 dark:border-color-white/20 dark:text-color-white">Artist</div>
                            <div class="table-cell border-b border-color-gray-200 p-4 pt-0 pr-8 pb-3 text-left font-medium text-color-gray-400 dark:border-color-white/20 dark:text-color-white">Year</div>
                        </div>
                    </div>
                    <div class="table-row-group dark:bg-color-black/5">
                        <div class="table-row">
                            <div class="table-cell border-b border-color-gray-100 p-4 pl-8 text-color-gray-500 dark:border-color-white/10 dark:text-color-gray-300">The Sliding Mr. Bones (Next Stop, Pottersville)</div>
                            <div class="table-cell border-b border-color-gray-100 p-4 text-color-gray-500 dark:border-color-white/10 dark:text-gray-color-300">Malcolm Lockyer</div>
                            <div class="table-cell border-b border-color-gray-100 p-4 pr-8 text-color-gray-500 dark:border-color-white/10 dark:text-color-gray-300">1961</div>
                        </div>
                        <div class="table-row">
                            <div class="table-cell border-b border-color-gray-100 p-4 pl-8 text-color-gray-500 dark:border-color-white/10 dark:text-color-gray-300">The Sliding Mr. Bones (Next Stop, Pottersville)</div>
                            <div class="table-cell border-b border-color-gray-100 p-4 text-color-gray-500 dark:border-color-white/10 dark:text-gray-color-300">Malcolm Lockyer</div>
                            <div class="table-cell border-b border-color-gray-100 p-4 pr-8 text-color-gray-500 dark:border-color-white/10 dark:text-color-gray-300">1961</div>
                        </div>
                        <div class="table-row">
                            <div class="table-cell border-b border-color-gray-100 p-4 pl-8 text-color-gray-500 dark:border-color-white/10 dark:text-color-gray-300">The Sliding Mr. Bones (Next Stop, Pottersville)</div>
                            <div class="table-cell border-b border-color-gray-100 p-4 text-color-gray-500 dark:border-color-white/10 dark:text-gray-color-300">Malcolm Lockyer</div>
                            <div class="table-cell border-b border-color-gray-100 p-4 pr-8 text-color-gray-500 dark:border-color-white/10 dark:text-color-gray-300">1961</div>
                        </div>
                    </div>
                </div>
            </div>
<div class="relative flex gap-4 rounded-lg text-center font-mono text-sm leading-6 font-bold text-color-white">
                <div class="absolute inset-0">
                    <div class="h-full rounded-lg border text-color-black/10 dark:text-color-white/12.5 bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)]"></div>
                </div>
                <div class="hidden h-14 w-14 rounded-lg bg-color-purple-500 p-4">01</div>
                <div class="relative h-14 w-14 rounded-lg bg-color-purple-500 p-4">02</div>
                <div class="relative h-14 w-14 rounded-lg bg-color-purple-500 p-4">03</div>
            </div>
</div>